import { BrowserRouter, Route, Routes } from 'react-router-dom';
import type { ComponentConfig } from '@cbhq/cds-web/core/componentConfig';
import { VStack } from '@cbhq/cds-web/layout';
import { MediaQueryProvider, ThemeProvider } from '@cbhq/cds-web/system';
import { ComponentConfigProvider } from '@cbhq/cds-web/system/ComponentConfigProvider';
import { coinbaseTheme } from '@cbhq/cds-web/themes/coinbaseTheme';
import { TextBody } from '@cbhq/cds-web/typography';

import { TokenRoute } from './routes/TokenRoute';

// Local copy of `legacyInputLabelConfig` from `@cbhq/identity-shared/web`, which this app does not
// depend on. Keep the two in sync. cds-web 9.20 changed the default input label style from
// label1/fg (bold) to label2/fgMuted; this keeps the bold labels until the retail design refresh.
// RET-2119 will remove this override for the refresh cohort.
const legacyInputLabelConfig: ComponentConfig = {
  TextInput: { labelFont: 'label1', labelColor: 'fg' },
  Select: { labelFont: 'label1', labelColor: 'fg' },
  Combobox: { labelFont: 'label1', labelColor: 'fg' },
};

function Home() {
  return (
    <VStack alignItems="center" justifyContent="center" height="100vh">
      <TextBody>👍</TextBody>
    </VStack>
  );
}

export function App() {
  return (
    <MediaQueryProvider>
      <ComponentConfigProvider value={legacyInputLabelConfig}>
        <ThemeProvider theme={coinbaseTheme} activeColorScheme="light" isolated>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/:token" element={<TokenRoute />} />
            </Routes>
          </BrowserRouter>
        </ThemeProvider>
      </ComponentConfigProvider>
    </MediaQueryProvider>
  );
}
